export const environment = {
  production: true,
  jwtTokenCookieName: 'mycommunity.ng.token',
  userIdCookieName: 'mycommunity.ng.userId'
};
